// extracted by mini-css-extract-plugin
module.exports = {"main":"MobileApps_main__H3tAt","item":"MobileApps_item__3Gx94","img":"MobileApps_img__1oYlV"};